import {ServiceClass} from '@/decorators';
import {
    AccountViewModel,
    PasswordResetConfirmModel,
    PasswordResetRequestModel,
    PasswordResetVerifyModel,
    PhoneVerificationRequestModel,
    PhoneVerificationVerifyModel,
    SessionModel,
    SignupViewModel,
    UserViewModel,
} from '../models';
import {BaseApi} from './base.api';

@ServiceClass()
export class AutentictionApi extends BaseApi {
    public Login(data: any) {
        return this.POST_Request<SessionModel>(`${this.ApiUrl}/authentication/login`, data);
    }
    public CreateAccount(data: any) {
        return this.POST_Request<SessionModel>(`${this.ApiUrl}/users`, data);
    }

    public SignupAdmin(data: SignupViewModel) {
        return this.POST_RequestAsync<{user: any; account: AccountViewModel}>(`${this.ApiUrl}/authentication/signup-admin`, data);
    }

    public SignupUser(data: SignupViewModel) {
        return this.POST_RequestAsync<UserViewModel>(`${this.ApiUrl}/authentication/signup-user`, data);
    }

    public RequestPhoneVerification(data: PhoneVerificationRequestModel) {
        return this.POST_RequestAsync<{expiresAt: string; resendAvailableAt: string}>(`${this.ApiUrl}/authentication/phone/request`, data);
    }

    public VerifyPhoneVerification(data: PhoneVerificationVerifyModel) {
        return this.POST_RequestAsync<{ok: true}>(`${this.ApiUrl}/authentication/phone/verify`, data);
    }

    public RequestPasswordResetCode(data: PasswordResetRequestModel) {
        return this.POST_RequestAsync<{expiresAt: string; resendAvailableAt: string}>(`${this.ApiUrl}/authentication/password-reset/request`, data);
    }

    public VerifyPasswordResetCode(data: PasswordResetVerifyModel) {
        return this.POST_RequestAsync<{resetToken: string; expiresAt: string}>(`${this.ApiUrl}/authentication/password-reset/verify`, data);
    }

    public ConfirmPasswordReset(data: PasswordResetConfirmModel) {
        return this.POST_RequestAsync<{ok: true}>(`${this.ApiUrl}/authentication/password-reset/confirm`, data);
    }
}
